export interface AppConfig {
  appName: string;
  baseHref: string;
  appKey: string;
  datePattern: string;
  currencyPattern: string;
  dataServiceBaseUrl: string;
  dataServiceApiKey: string;
  dataServiceSessionId: string;
  businessRulesBaseURL: string;
  contentServiceBaseUrl: string;
  requestAccessUrl: string;
  oktaUrl: string;
  logging: {
    console: boolean;
    appInsightEnabled: boolean;
    appInsights: {
      instrumentationKey: string;
      enableAutoRouteTracking: boolean;
    };
  };
}
